// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"222":"d2065547","549":"a3ad84b9"}[chunkId] + ".chunk.js";
};